import Mock from 'mockjs';

export default Mock.mock(/\/api\/devices\/.+.\/base\/resume/, {
  rst: 200,
  'data|1-10': [
    {
      'title|+1': ['@ctitle(3,5)', undefined],
      'value|+1': ['@integer(1, 10)', '@string(5)'],
    },
  ],
  msg: 'success',
});
